import {createUseStyles} from "react-jss";
import {breakpoints} from "../../../constants/breakpoints";
import {colors} from "../../../constants/colors";

const styles = createUseStyles(theme => ({
  resubmitRedemptionButton: {
    cursor: 'pointer'
  },
  modalContent: {
    margin: "20px 0 0 0"
  },
  footerBtns: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  checkbox: {
    marginRight: "12px"
  },
  resubmitRedeptionModal: {
    width: "400px",
    "& .modal-header": {
      padding: "24px 24px 20px 24px",
      "& div": {
        height: "46px",
        padding: "10px",
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px",
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "28px",
      overflowWrap: "break-word"
    },
    "& .body, .modal-body": {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
    },
    "& .modal-body": {
      padding: "8px 24px",

    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  btnContainer: {
    marginTop: "32px",
    marginBottom: "16px",
  },

  cancelBtn: {
    width: "100%",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "20px",
    fontFamily: theme.fontFamily,
    height: "100%",
    alignItems: "center"
  },
  createBtn: {
    height: "100%",
    alignItems: "center",
    width: "100%",
    backgroundColor: colors.darkBlue,
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "20px",
    fontFamily: theme.fontFamily,
  },
  colCancel: {
    padding: "0px",
    marginRight: "6px"
  },
  colRemove: {
    padding: "0px",
    marginLeft: "6px"
  },

}));

export default styles;
